import { Component } from 'vue-property-decorator';
import PageRender from './models/PageRender';

@Component
export default class AppComponent extends PageRender {}
